import { colorStrings, mediaQueriesBP } from "@iewcasia/Utilities/variables";
import buttonSizeVariants from "@insite/mobius/Button/buttonSizeVariants";
import { FormFieldClickable, FormFieldPresentationProps, FormFieldPropsMock } from "@insite/mobius/FormField";
import get from "@insite/mobius/utilities/get";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { css } from "styled-components";

export const commonTypoStyles = css`
    font-size: 16px;
    line-height: 26px;

    ${mediaQueriesBP.minMD} {
        font-size: 16px;
        line-height: 26px;
    }
`;

export const formField: RecursivePartial<{
    defaultProps?: FormFieldPresentationProps<FormFieldPropsMock> | undefined;
}> = {
    defaultProps: {
        errorProps: {
            mergeCss: true,
            weight: 400,
            color: colorStrings.dangerMain,
            css: css`
                font-size: 10px;
                line-height: 14px;

                ${mediaQueriesBP.minMD} {
                    font-size: 12px;
                    line-height: 16px;
                }
            `,
        },
        cssOverrides: {
            formInputWrapper: css`
                input,
                input:not(.react-datetime-picker__inputGroup__input),
                select,
                select:not(.react-datetime-picker__inputGroup__input),
                .react-datetime-picker {
                    ${commonTypoStyles}
                    padding: 0 8px;
                    border: 1px solid ${getColor(colorStrings.commonGlobalGray01)};
                    background: ${getColor(colorStrings.commonGlobalWhite)};

                    .react-datetime-picker__inputGroup__input {
                        padding: 0 2px 0;
                        &:focus {
                            padding: 0 2px 0;
                        }
                    }

                    &:focus {
                        border-color: ${getColor(colorStrings.commonGlobalGray03)};
                        padding: 0 16px;
                    }

                    &:disabled {
                        color: ${getColor(colorStrings.commonGlobalGray03)};
                        background: ${getColor(colorStrings.commonGlobalWhite)};
                        border: 1px solid ${getColor(colorStrings.commonGlobalGray03)};

                        &::placeholder {
                            color: ${getColor(colorStrings.commonGlobalGray03)};
                        }

                        & + span,
                        & + span ~ span {
                            color: ${getColor(colorStrings.commonGlobalGray03)};
                            background: transparent !important;

                            svg {
                                color: ${getColor(colorStrings.commonGlobalGray03)};
                            }
                        }

                        & + button {
                            svg {
                                stroke: ${getColor(colorStrings.commonGlobalGray03)};
                            }

                            span {
                                background: transparent !important; /* Avoid using !important */
                            }
                        }
                    }

                    ${mediaQueriesBP.minMD} {
                        padding: 0 16px;
                    }
                }

                select {
                    ${commonTypoStyles}
                    border-color: ${getColor(colorStrings.commonGlobalGray01)};
                    &:focus {
                        border-color: ${getColor(colorStrings.commonGlobalGray01)};

                        padding: 0 32px 0 10px !important; /* Avoid using !important */
                    }

                    &:disabled {
                        color: ${getColor(colorStrings.commonGlobalGray03)};
                    }
                }

                textarea {
                    &:focus {
                        border-color: ${getColor(colorStrings.commonGlobalGray01)};
                        padding: 0 16px;
                    }
                    &:disabled {
                        color: ${getColor(colorStrings.commonGlobalGray03)};
                    }
                }

                ${FormFieldClickable} {
                    width: 30px;

                    ${mediaQueriesBP.minMD} {
                        width: 50px;
                    }
                }
            `,
            inputSelect: css`
                ${commonTypoStyles}

                &:disabled {
                    background-color: ${getColor(colorStrings.commonGlobalWhite)};
                }
            `,
            formField: css`
                ${commonTypoStyles};

                input,
                input:not(.react-datetime-picker__inputGroup__input),
                select:not(.react-datetime-picker__inputGroup__input),
                textarea,
                .mobiusFileUpload {
                    ${commonTypoStyles};
                    background: ${getColor(colorStrings.commonGlobalWhite)};
                }
            `,
        },
        labelProps: {
            weight: 700,
            color: colorStrings.textMain,
            css: css`
                ${commonTypoStyles}

                [disabled] & {
                    color: ${getColor(colorStrings.textDisabled)};
                }
            `,
        },
    },
};
